module.exports = __webpack_public_path__ + "static/media/wave-shap.fbb7b0d2.svg";